import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/site';
import { ui } from '../data/ui';
import { buttonClass } from '../utils/styles';
export function NotFound() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white" data-id="element-506" data-mp="155r12xdkactz">
      <div className="mx-auto max-w-2xl px-6 py-24 text-center sm:py-32" data-id="element-507" data-mp="152la1cldh0vm">
        <p className="font-display text-lg italic text-gold-dark" data-id="element-508" data-mp="1a3sgn8bs3u0p">404</p>
        <h1 className="mt-3 font-display text-3xl text-navy sm:text-4xl" data-id="element-509" data-mp="1f23s1nhq2cl1">
          {t({
          en: 'That page moved or never existed',
          es: 'Esa página se movió o nunca existió'
        })}
        </h1>
        <p className="mt-4 text-lg text-ink/75" data-id="element-510" data-mp="1nunsmthkqr8i">
          {t({
          en: 'Let us get you back to the work. Browse our services or call for a free estimate.',
          es: 'Volvamos a lo importante. Explora nuestros servicios o llama para un presupuesto gratis.'
        })}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-511" data-mp="1nx5byvjcp5ry">
          <Link to="/" className={buttonClass('gold', 'md')} data-id="element-512" data-mp="1ivzigvhv9ehd">
            {t({
            en: 'Back to home',
            es: 'Volver al inicio'
          })}
          </Link>
          <a href={business.phoneHref} className={buttonClass('outline', 'md')} data-id="element-513" data-mp="1ex0dxc01rjqg">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-514" data-mp="19xxce1j9zvn8" />
            {t(ui.callNow)}
          </a>
        </div>
      </div>
    </section>;
}